const API_ROOT = '/api/startups'

export const getStartupsUrl = () => `${API_ROOT}/startups`

export const getPlatformStartupsUrl = () => `${API_ROOT}/startups/platform`

export const getStartupUrl = ( id ) => `${API_ROOT}/startup/${id}`

export const getStartupData = () => `${API_ROOT}/startups/data`
